import { Localization } from "../../../common/localizable-component";
import { InputLocalization } from "./input-types";
import { deepmerge } from "../../../utils/deep-merge";
import { FORM_LOCALIZATION } from "../../form/constants/form-i18n";

export const INPUT_LOCALIZATION: Localization<InputLocalization> = deepmerge(FORM_LOCALIZATION, {
  en: {
    dateFormat: "MM.dd.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "y",
    locale: "en-US"
  },
  de: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "t",
    localeMonth: "m",
    localeYear: "j",
    locale: "de-DE"
  },
  sv: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "å",
    localeMonth: "m",
    localeYear: "y",
    locale: "sv"
  },
  nl: {
    dateFormat: "dd.MM.yyyy",
    localeDay: "d",
    localeMonth: "m",
    localeYear: "j",
    locale: "nl-NL"
  }
});
